import React from 'react';
import { BRAND_LIBRARY_LIGHT_TEXT_COLOR } from 'common/constants/brandLibrary';
import Block from './SessionsBlock.styles';

export default function PastSessionsBlock(props) {
    return <Block {...props} />;
}

PastSessionsBlock.splash = {
    ...Block.splash,
    defaultProps: {
        ...Block.splash.defaultProps,
        styles: {
            ...Block.splash.defaultProps.styles,
            backgroundColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
        },
    },
};
